import './navigation';
import './header';
import './baner_hands';
import './ajax-add-to-cart';


document.addEventListener("DOMContentLoaded", function() {
  const scrollLine = document.querySelector(".scroll-line2");
  const content = document.querySelector(".page-id-14");
  const allForLawSection = document.querySelector(".scroll_container");

  const observer = new IntersectionObserver(entries => {
    const isVisible = entries[0].isIntersecting;

    if (isVisible) {
      // Dodaj klasę "active" gdy sekcja .AllForLaw jest widoczna
      scrollLine.classList.add("active");
    } else {
      // Usuń klasę "active" gdy sekcja .AllForLaw nie jest widoczna
      scrollLine.classList.remove("active");
    }
  });

  observer.observe(allForLawSection);

  window.addEventListener("scroll", function() {
    const scrollPercentage = (window.scrollY / (content.offsetHeight - window.innerHeight)) * 100;

    // Ustaw widoczność paska przewijania
    scrollLine.style.top = `${scrollPercentage}%`;
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const scrollLine = document.querySelector(".scroll-line3");
  const content = document.querySelector(".page-id-14");
  const allForLawSection = document.querySelector(".scroll_container");

  const observer = new IntersectionObserver(entries => {
    const isVisible = entries[0].isIntersecting;

    if (isVisible) {
      // Dodaj klasę "active" gdy sekcja .AllForLaw jest widoczna
      scrollLine.classList.add("active");
    } else {
      // Usuń klasę "active" gdy sekcja .AllForLaw nie jest widoczna
      scrollLine.classList.remove("active");
    }
  });

  observer.observe(allForLawSection);

  window.addEventListener("scroll", function() {
    const scrollPercentage = (window.scrollY / (content.offsetHeight - window.innerHeight)) * 100;

    // Ustaw widoczność paska przewijania
    scrollLine.style.top = `${scrollPercentage}%`;
  });
});

